const state = {
    authorCode: window.localStorage.getItem('authorCode') ? window.localStorage.getItem('authorCode'):[],
    userInfo: window.localStorage.getItem('userInfo') ? window.localStorage.getItem('userInfo'):'',
    cancalActiveName:'',
    tasksInfoData:{},//任务详情页信息数据
    tasksAcceptancesStatistics:{},//任务验收数量统计
    tasksAcceptancesList:[],//任务验收列表
    tasksAcceptancesData:[],

}

export default state
